import styled from 'styled-components';

export const RemoveFromFolder = styled.div``;
